/**
 * Script ultra-simple pour forcer la mise à jour des prix sur la page panier
 */

(function() {
  // Seulement sur la page panier
  if (!window.location.pathname.includes('/cart')) {
    return;
  }
  
  // Fonction simple pour mettre à jour les prix
  function refreshCartPrices() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Mettre à jour chaque ligne d'article
        cart.items.forEach((item, index) => {
          // Chercher les éléments de prix pour cette ligne
          const row = document.querySelector(`tr.cart_item:nth-child(${index + 1}), tr.shopify-cart-form__cart-item:nth-child(${index + 1})`);
          if (row) {
            // Prix unitaire
            const priceCell = row.querySelector('.product-price .money');
            if (priceCell && item.price > 0) {
              priceCell.textContent = (item.price / 100).toFixed(2) + ' dhs';
            }
            
            // Prix total ligne
            const totalCell = row.querySelector('.product-subtotal .money');
            if (totalCell && item.line_price > 0) {
              totalCell.textContent = (item.line_price / 100).toFixed(2) + ' dhs';
            }
          }
        });
        
        // Mettre à jour le total
        if (cart.total_price > 0) {
          const totalElements = document.querySelectorAll('.cart_total_price, .pplr_subtotal_price');
          totalElements.forEach(el => {
            el.textContent = (cart.total_price / 100).toFixed(2) + ' dhs';
          });
        }
      })
      .catch(console.error);
  }
  
  // Lancer la mise à jour après un court délai
  setTimeout(refreshCartPrices, 300);
  
  // Relancer périodiquement si nécessaire
  const interval = setInterval(() => {
    // Vérifier s'il y a encore des prix à 0
    const zeroPrices = document.querySelectorAll('.money');
    let hasZeroPrice = false;
    
    zeroPrices.forEach(el => {
      if (el.textContent.includes('0.00') || el.textContent.includes('0,00')) {
        hasZeroPrice = true;
      }
    });
    
    if (hasZeroPrice) {
      refreshCartPrices();
    } else {
      // Arrêter l'intervalle si tous les prix sont corrects
      clearInterval(interval);
    }
  }, 2000);
  
  // Arrêter l'intervalle après 30 secondes max
  setTimeout(() => clearInterval(interval), 30000);
  
})();
